import { IAssembly } from './Assembly';
import { IDaypart } from './Daypart';
import { ILocationGroup } from './LocationGroup';
import { IScheduleOverride } from './ScheduleOverride';

export interface IScheduleAssembly {
  id: number;
  location_group_id: number;
  daypart_id: number;
  assembly_id: number;
  location_code: string | null;
  assembly?: IAssembly;
  daypart?: IDaypart;
  start_date: string;
  end_date: string;
  config: string;
  created_at: string;
  modified_at: string;
}
export interface IDefaultAssembly {
  id: number;
  location_group_id: number;
  locationGroup?: ILocationGroup;
  daypart_id: number;
  assembly_id: number;
  assembly?: IAssembly;
  daypart?: IDaypart;
  config: string;
  created_at: string;
  modified_at: string;
  valid_to: string;
  start_date?: string;
  narrative?: string;
  status?: AssemblyStatus;
}

export interface IScheduleComponentAssembly
  extends IViewLocationLayoutsWithScheduleAssemblies {
  selectedSection?: { layoutScreenId: number; screenSectionId: number };
  scheduleComponentOverride?: IScheduleOverride;
}

export interface IViewLocationLayoutsWithScheduleAssemblies {
  id: string;
  location_code: string;
  location_tag_id: number[];
  scheduledOrDefault: string;
  daypart: {
    name: string;
  };
  assembly: IAssembly;
  schedule_assembly: {
    id: number;
    location_group_id: number;
    daypart_id: number;
    assembly_id: number;
    start_date: string;
    end_date: string | null;
    modified_at: string | null;
  };
  store_number: string;
}

export enum AssemblyStatus {
  SCHEDULED = 'Scheduled',
  LIVE = 'Live',
  EXPIRED = 'Expired',
}
